export enum ServiceTypes {
  MOBILE_PREPAID = 'MOBILE_PREPAID',
  MOBILE_POSTPAID = 'MOBILE_POSTPAID',
  COMBINE = 'KOMBINUJ',
  ADSL = 'ADSL',
  IPTV = 'IPTV',
  TEL = 'TEL',
  MOBILE_PREPAID_DOPUNA_NET = 'MOBILE_PREPAID_DOPUNA_NET',
  MSAT='MSAT',
  NET_POSTPAID='NET_POSTPAID',
}

export const ServiceTypesIcons = {
	[ServiceTypes.MOBILE_PREPAID]: 'mobile',
	[ServiceTypes.MOBILE_POSTPAID]: 'mobile',
	[ServiceTypes.MOBILE_PREPAID_DOPUNA_NET]: 'mobile',
	[ServiceTypes.NET_POSTPAID]: 'internet',
	[ServiceTypes.COMBINE]: 'mobile',
	[ServiceTypes.ADSL]: 'internet',
	[ServiceTypes.IPTV]: 'tv',
	[ServiceTypes.MSAT]: 'tv',
	[ServiceTypes.TEL]: 'fix-tel',
};
